export  const newAluno = {
    id: 0,
    Name: "",
    NomeSocial: "",
    email: "",
    MobileNumber: "",
    PhoneNumber: "",
    Mother: "",
    Father: "",
    BirthDate: null,
    BirthPlace: "",
    Nationality: "",
    Gender: '0',
    MaritalStatus: '0',
    IndividualIdentity: "",
    Identity0: "",
    IdentityEmitter: "",
    ElectionIdentity: "",
    ElectionZone: "",
    MilitarIdentity: "",
    Comment: "",
    ZipCode: "",
    Address: "",
    Address2: "",
    StreetNumber: "",
    Neighborhood: "",
    City: "",
    StateAddress: "",
    WorkAt: "",
    ProfAddress: "",
    ProfCity: "",
    ProfPhone: "",
    PictureFile: null,
    
}
